// extracted by mini-css-extract-plugin
export default {"component":"T2UjV0","icon":"Yd9c4K","mobile":"LBHkhr","title":"mmjLyN","button":"fuTF26"};